import { IFieldProps } from 'decorator-form';
import * as React from "react";
import { connect } from 'react-redux';

import { Button, Callout, Label, Popover } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import autobind from 'autobind-decorator';
import IPropertyRecord from "core/util/property/IPropertyRecord";
import IPropertyType from "core/util/property/IPropertyType";
import { PropertyProvider } from 'core/util/property/PropertyProvider';
import PropertyTypeRegistry from "core/util/property/PropertyTypeRegistry";
import { type } from 'os';
import PropertyList from './PropertyList';

export interface IPropertyReferencePickerProps extends IFieldProps<any> {
	type: string;
	record?: IPropertyRecord<any>; // resolved record
	args: object;
}

interface IPropertyReferencePickerState {
	mode: "display" | "edit" | "new";
}

class PropertyReferencePicker extends React.Component<IPropertyReferencePickerProps, IPropertyReferencePickerState> {
	private type: IPropertyType<any, any>;

	constructor(props: IPropertyReferencePickerProps) {
		super(props);

		this.state = {
			mode: PropertyProvider.isValidRecord(this.props.formData) ? "display" : "new"
		};

		this.type = PropertyTypeRegistry.get(props.type);
	}

	@autobind
	private renderInput() {
		const { formData, record, onChange } = this.props;
		const { mode } = this.state;

		/*// new mode
		if("new" === mode) {
			return (
				<Button onClick={() => this.setState({mode: "edit"})}>Select</Button>
			);
		}

		// edit mode
		if("edit" === mode || !record) {
			return (
				<PropertyList scope="properties" group="default" onClick={(type, reference) => {
					 // set the new reference
					this.setState({mode: "display"}, () => onChange(reference));
				}} />
			);
		}

		// display mode
		if("display" === mode) {
			return (
				record && <a onClick={() => this.setState({mode: "edit"})}>
					<Callout icon={IconNames.EDIT}>
						{this.type.getPreviewElement(record.value, true, record)}
					</Callout>
				</a>
			);
		} */

		const editor = (
			<div style={{padding: "15px"}}>
				<PropertyList scope="properties" group="default" type={this.type.name} onClick={(type, reference) => {
					// set the new reference
					onChange(reference);
				}} />
			</div>
		);

		return (
			<Popover content={editor}>
				{record ? (
					<Callout icon={IconNames.EDIT} style={{cursor: "pointer"}}>
						{this.type.getPreviewElement(record.value ? record.value : this.type.getDefaultValue(), true, record)}
					</Callout>
				) : (
					<Button>Select</Button>
				)}
			</Popover>
		);
	}

	public render() {
		return (
			<React.Fragment>
				<Label>
					{this.props.label}
					<small>{this.type.label + " Reference"}</small>
				</Label>
				{this.renderInput()}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state, {formData}: IPropertyReferencePickerProps) => {

	if(PropertyProvider.isValidReference(formData)) {
		return {
			record: PropertyProvider.getRecord(formData, state)
		};
	}

	return { record: null };
};

export default connect(mapStateToProps)(PropertyReferencePicker);











// WEBPACK FOOTER //
// ./src/core/components/editor/properties/PropertyReferencePicker.tsx